var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
const focusableElementsString = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
export function FocusTrap(_a) {
    var { children, preventAutofocus } = _a, props = __rest(_a, ["children", "preventAutofocus"]);
    const [ref, setRef] = useState();
    useEffect(() => {
        if (!ref)
            return;
        const onTabPress = (ev) => {
            const { key, shiftKey } = ev;
            if (key !== 'Tab')
                return;
            const focusableElements = [...document.querySelectorAll(focusableElementsString)];
            const currentFocused = focusableElements.findIndex(el => el === document.activeElement);
            if (currentFocused === -1) {
                const firstFocusable = ref.querySelector(focusableElementsString);
                firstFocusable && firstFocusable.focus();
                return;
            }
            const nextFocused = focusableElements[currentFocused + (shiftKey ? -1 : 1)];
            if (!ref.contains(nextFocused)) {
                ev.preventDefault();
                const focusableArr = [...ref.querySelectorAll(focusableElementsString)];
                const focusable = shiftKey ? focusableArr[focusableArr.length - 1] : focusableArr[0];
                focusable && focusable.focus();
            }
        };
        document.addEventListener('keydown', onTabPress);
        return () => {
            document.removeEventListener('keydown', onTabPress);
        };
    }, [ref]);
    useEffect(() => {
        if (!ref)
            return;
        if (preventAutofocus)
            return;
        const focusable = ref.querySelector(focusableElementsString);
        focusable && focusable.focus();
    }, [ref, preventAutofocus]);
    return React.createElement("div", Object.assign({ className: "ltg-focus-trap", ref: setRef }, props), children);
}
